import React, { Component } from "react";
import withStyles from "@material-ui/core/styles/withStyles";

import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import MenuItem from '@material-ui/core/MenuItem';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';


import { Services } from "baseparking-api";

const carTypes = [
    { value: 'allar', label: 'Allar Stærðir' },
    { value: 'folksbill', label: 'Fólksbíll' },
    { value: 'jeppi', label: 'Jeppi' },
    { value: 'jepplingur', label: 'Jepplingur' },
    { value: 'yfirstaerd', label: 'Yfirstærð' },
];

const styles = {

};

class CreateService extends Component {
    constructor(props) {
        super(props);
        this.state = {
            label: '',
            price: '',
            sizeSpecific: null,
            daily: false,
            editing: null,
        }
    }

    componentWillMount() {
        const { service } = this.props;
        if (!!service) {
            console.log(service);
            // editing
            this.setState({
                editing: service._id,
                label: service.label,
                price: service.price,
                sizeSpecific: service.sizeSpecific || 'allar',
                daily: service.daily,
            })
        }
    }

    handleClickOpen = () => {
        this.setState({ open: true });
    };

    handleClose = () => {
        this.setState({ open: false });
    };

    handleSizeSelection = sizeSpecific =>
        this.setState({ sizeSpecific });

    onSubmit = e => {
        e.preventDefault();
        const { editing, label, price, sizeSpecific, daily } = this.state;
        if (label, price, sizeSpecific) {
            if (editing) {
                // editing
                Services.update({
                    _id: editing,
                    label,
                    price,
                    sizeSpecific: (sizeSpecific === 'allar') ? null : sizeSpecific,
                    active: true,
                    daily,
                })
                    .then(res => {
                        console.log(res);
                        console.log(sizeSpecific);
                        this.props.onComplete();
                    })
                    .catch(console.error);
            } else {
                // creating
                Services.create({
                    label,
                    price,
                    sizeSpecific: (sizeSpecific === 'allar') ? null : sizeSpecific,
                    active: true,
                    daily,
                })
                    .then(res => {
                        console.log(res);
                        console.log(sizeSpecific);
                        this.props.onComplete();
                    })
                    .catch(console.error);
            }
        } else {

        }
    }

    render() {
        const { classes } = this.props;

        return (
            <Dialog
                open={this.props.open}
                onClose={this.props.onClose}
                aria-labelledby="form-dialog-title"
            >
                <form onSubmit={this.onSubmit}>
                    <DialogTitle id="form-dialog-title">Stofna Nýja Þjónustu</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            Þjónustan sem stofnuð verður er sjálfkrafa virk og birtist hún því strax á framendum kerfisins.
                    </DialogContentText>
                        <TextField
                            autoFocus
                            margin="dense"
                            id="name"
                            label="Nafn Þjónustu"
                            value={this.state.label}
                            onChange={e => this.setState({ label: e.target.value })}
                            type="text"
                            fullWidth
                        />
                        <TextField
                            margin="dense"
                            id="name"
                            label="Verð þjónustu"
                            type="number"
                            value={this.state.price}
                            onChange={e => this.setState({ price: e.target.value })}
                            fullWidth
                        />
                        <TextField
                            select
                            label="Stærðarflokkur"
                            value={this.state.sizeSpecific}
                            onChange={e => this.handleSizeSelection(e.target.value)}
                            margin="normal"
                            tabIndex={2}
                            fullWidth
                        >
                            {carTypes.map(option => (
                                <MenuItem key={option.value} value={option.value}>
                                    {option.label}
                                </MenuItem>
                            ))}
                        </TextField>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={this.state.daily}
                                    onChange={val => this.setState({ daily: val })}
                                    value="checkedB"
                                    color="primary"
                                />}
                            label="er kostnaður þjónustu daglegur?"
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={e => this.props.onClose()} color="primary">
                            Hætta Við
                    </Button>
                        <Button color="primary" type="submit">
                            Staðfesta
                    </Button>
                    </DialogActions>
                </form>
            </Dialog>
        )
    }
}

export default withStyles(styles)(CreateService);


// WEBPACK FOOTER //
// ./src/views/Services/CreateService.jsx